import apiClient from './client';
import { City } from '../types/city'; 

const API_BASE_URL = 'https://rulla.pro/api/v1';

// поиск по строке
export interface CitySearchResult {
  cityId: string;
  cityName: string;
  matchType: 'CITY';
  matchId: string;
  matchName: string;
  score: number;
}

export const citiesApi = {
  // Получение всех городов
  getAllCities: async (): Promise<City[]> => {
    const url = `${API_BASE_URL}/geo/cities`;
    try {
      const response = await apiClient.get<City[]>(url);
      return response.data;
    } catch (err) {
      console.error(`[citiesApi] Ошибка при GET ${url}:`, err);
      throw err;
    }
  },

  // Поиск городов по названию
  searchCities: async (query: string, minScore = 0.1): Promise<CitySearchResult[]> => {
    if (!query.trim()) return [];

    const url = `${API_BASE_URL}/geo/cities/search`;

    try {
      const response = await apiClient.get<CitySearchResult[]>(url, {
        params: { 
          q: query.trim(), 
          minScore 
        },
      });
      return response.data;
    } catch (err) {
      return [];
    }
  },

  // Ближайший город по координатам
  getNearestCity: async (lat: number, lon: number): Promise<City> => {
    const url = `${API_BASE_URL}/geo/cities/nearest`;

    try {
      const response = await apiClient.get<City>(url, {
        params: { lat, lon },
      });
      return response.data;
    } catch (err) {
      throw err;
    }
  },
};